import generatorRow from '@/components/generator/row'
import fallback from '@/components/rules/actions/generators/fallbacks/fallback'
import { defaultFallback } from '@/components/rules/utils'

function renderItem(h, item, index) {
  return h(
    fallback,
    {
      props: {
        value: item
      },
      on: {
        input: event => {
          this.$set(this.proxy, index, event)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy,
        defaultValue: defaultFallback
      },
      scopedSlots: {
        row: ({ item, index }) => {
          return renderItem.call(this, h, item, index)
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
